{
  "feedback-process-pages": {
    "feedback-process-steps": {
      "step-1": {
        "title": "Your satisfaction",
        "description": "Are you satisfied with our service"
      },
      "step-2": {
        "title": "Your feedback",
        "description": "Write your feedback"
      },
      "step-3": {
        "title": "Feedback sent",
        "description": "Your feedback is sent"
      }
    },
    "meta": {
      "title": "Feedback",
      "description": "Your feedback"
    }
  }
}
